<template>
    <div>
        <li>
            <a :href="cartLink">
                <i class="fas fa-shopping-cart"
                    >(<span id="shoptext" v-text="quantity"></span>)</i
                >
            </a>
        </li>
    </div>
</template>

<script>
    import eventHub from "../../../library/event-hub";

    export default {
        data() {
            return {
                cartList: [],
                cartLink: `${base_url}/orders`,
            };
        },
        computed: {
            quantity() {
                let quantity = 0;
                this.cartList.forEach((item) => (quantity += item.quantity));
                return quantity;
            },
        },
        methods: {
            loadCartstatus() {
                let api_url = `${base_url}/api/carts`;
                axios
                    .get(api_url)
                    .then((response) => {
                        this.cartList = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        },

        mounted() {
            this.loadCartstatus();
            eventHub.$on("cart-updated", (cartList) => (this.cartList = cartList));
        },
    };
</script>


<style scoped>
</style>